module.exports = __webpack_public_path__ + "img/david_banister.08ec908d.jpg";